import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DeleteStackGarment, modifyStackGarment } from "../functions";
import { showMessage } from "store/modules/Message";

const StackGarmentDelete = ({ openDelete, setOpenDelete, setRender }) => {
  const dispatch = useDispatch();
  const { defaultData } = useSelector(({ stackGarment }) => stackGarment);
  const messages = (mensaje) => {
    dispatch(
      showMessage({
        message: `El modelo se ha ${mensaje} con éxito`,
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      })
    );
  };

  const deleteFnc = async () => {
    setRender(true);
    await Promise.all(
      defaultData.tallas.map((item) => {
        const data = {
          id: item.id,
          producto: { id: item.idProducto },
          talla: { id: item.idTalla },
          cantidad: null,
          descripcion: null,
        };
        return DeleteStackGarment(data);
      })
    );
    messages("eliminado");
    setOpenDelete(false);
    setRender(false);
  };
  return (
    <>
      <Dialog
        open={openDelete}
        onClose={() => {
          setOpenDelete(false);
        }}
      >
        <DialogTitle>
          <Typography variant="title">{"¡¡Advertencia!!"}</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle">
            {
              "¿Deseas eliminar este modelo del inventario?. Considera que se eliminará de la base de datos de forma permanente"
            }
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={deleteFnc} color="primary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StackGarmentDelete;
